<template>
    <button id="VOLUME_UP" name="VOLUME_UP" class="btn" data-vcode="VolumeUp" disabled :aria-label="`${$t('volumeUp')}`">
        <img src="/images/icons/volumeUp.svg" alt="" />
        <label aria-hidden="true">{{ $t('volumeUp') }}</label>
    </button>
</template>
<script>
export default {};
</script>
